import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';

function DuplicateDeleteModal({ onOpen, codeItem, toggle, title }) {
  const uniqueTypeErr = [...new Set(codeItem?.errTemplates?.map((item) => item?.type))];
  const errLength = codeItem?.errTemplates?.length;

  const uniqueTypeRemove = [...new Set(codeItem?.removedElements?.map((item) => item?.type))];
  const removeLength = codeItem?.removedElements?.length;
  const { t } = useTranslation('common');

  return (
    <Modal show={onOpen} backdrop="static" className="custom-modal modal-small" onHide={toggle}>
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {errLength > 0 ? <b>{t('DUPLICATE_DELETE_MODAL.DUPLICATE_CODES')}</b> : null}

        {uniqueTypeErr.length > 0 &&
          uniqueTypeErr.map((type, i) => {
            return (
              <div className="mb-3" key={type}>
                <p className="mb-1 text-capitalize">
                  <b>{type}</b>
                </p>
                <p className="mb-0">
                  {codeItem?.errTemplates
                    .filter((val) => val.type === type)
                    .map((item) => item.code)
                    .join(',')}{' '}
                  {t('DUPLICATE_DELETE_MODAL.DUPLICATE_EXIT_CODE')}
                </p>
              </div>
            );
          })}

        {removeLength > 0 ? <b>{t('DUPLICATE_DELETE_MODAL.REMOVED_CODES')}</b> : null}

        {uniqueTypeRemove.length > 0 &&
          uniqueTypeRemove?.map((type) => {
            return (
              <div className="mb-3" key={`${JSON.stringify(type)}_uniqTypeRemove`}>
                <p className="mb-1 text-capitalize">
                  <b>{type}</b>
                </p>
                <p className="mb-0">
                  {codeItem?.removedElements &&
                    codeItem.removedElements
                      .filter((val) => val.type === type)
                      .map((item) => item.code)
                      .join(',')}{' '}
                  {t('DUPLICATE_DELETE_MODAL.ORIGINAL_ENTRY_DOES_NOT_EXISTS')}
                </p>
              </div>
            );
          })}

        <div className="modal-buttons mt-5 d-flex">
          <button onClick={toggle} className="btn btn-default" type="button">
            {t('DUPLICATE_DELETE_MODAL.CLOSE_BUTTON_LABEL')}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default DuplicateDeleteModal;
